import {NgModule, StaticProvider} from '@angular/core';
import {BrowserModule} from "@angular/platform-browser";
import {CommonModule} from "@angular/common";
import {platformBrowserDynamic} from "@angular/platform-browser-dynamic";
import {downgradeModule} from "@angular/upgrade/static";
import {ScrollingModule} from "@angular/cdk/scrolling";
import {HttpClientModule} from "@angular/common/http";
import {CommonsModule} from "../../commons/angular/commons.module";
import {TranslateModule} from "@ngx-translate/core";
import {NgbModule} from "@ng-bootstrap/ng-bootstrap";
import {NgxPermissionsModule} from "ngx-permissions";
import {FormsModule} from "@angular/forms";
import {NgSelectModule} from "@ng-select/ng-select";
import {
  RecommendationGroupsListItemsComponent
} from "./components/recommendation-groups-list-items/recommendation-groups-list-items.component";
import {
  RecommendationsListItemsComponent
} from "./components/recommendations-list-items/recommendations-list-items.component";
import {
  RecommendationGroupsListItemComponent
} from "./components/recommendation-groups-list-item/recommendation-groups-list-item.component";
import {
  RecommendationsListItemComponent
} from "./components/recommendations-list-item/recommendations-list-item.component";
import {
  RecommendationGroupsPanelLayoutComponent
} from "./components/recommendation-groups-panel-layout/recommendation-groups-panel-layout.component";
import {
  RecommendationPanelLayoutComponent
} from "./components/recommendation-panel-layout/recommendation-panel-layout.component";
import {RecommendationWidgetComponent} from "./components/recommendation-widget/recommendation-widget.component";
import {ParseParametersPipe} from "./pipes/parse-parameters.pipe";

@NgModule({
  declarations: [
    RecommendationWidgetComponent,
    RecommendationPanelLayoutComponent,
    RecommendationGroupsPanelLayoutComponent,
    RecommendationsListItemComponent,
    RecommendationGroupsListItemComponent,
    RecommendationsListItemsComponent,
    RecommendationGroupsListItemsComponent,
    ParseParametersPipe,
  ],
  imports: [
    BrowserModule,
    CommonModule,
    HttpClientModule,
    ScrollingModule,
    CommonsModule,
    NgbModule,
    TranslateModule.forChild(),
    NgxPermissionsModule.forChild(),
    FormsModule,
    NgSelectModule,
  ],
  providers: [],
  exports: [
    RecommendationWidgetComponent,
  ]
})

export class RecommendationModule {
  constructor() {
  }

  ngDoBootstrap() {
  }
}

const bootstrapRecommendationModule = (extraProviders: StaticProvider[]) => {
  const platformRef = platformBrowserDynamic(extraProviders);
  return platformRef.bootstrapModule(RecommendationModule);
};

export const downgradedRecommendationModule = downgradeModule(bootstrapRecommendationModule);

